import { ModalProvider } from '@Context/modalContext';
import AppRoutes from '@Routes/Routes';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { PortalContext } from '@kg-internal/pv3-uikit';
import config from './config.ts';

import './App.scss';
import '@Styles/global.scss';
import { REGULAR_ROLES } from './Utils/constants.tsx';

const env = import.meta.env.VITE_APP_DEPLOY_ENV;

const { graphqlUrl } = config.urls[env];

const client = new ApolloClient({
  uri: graphqlUrl,
  cache: new InMemoryCache(),
});

const App = () => (
  <PortalContext env={env} bypassHandbookCheck name='asset-control' version='1.0' permissions={REGULAR_ROLES}>
    <ApolloProvider client={client}>
      <ModalProvider>
        <AppRoutes />
      </ModalProvider>
    </ApolloProvider>
  </PortalContext>
);

export default App;
